import { RuleInstance } from '@jupiterone/jupiter-types';
import gql from 'graphql-tag';
import { QuestionRuleInstanceWithTags } from '@jupiterone/jupiter-web-toolkit/';
import { createUseQueryHook } from '../../../apollo/createUseQueryHook';
import { PageInfo } from '../../../types';
import {
  QuestionRuleInstanceFragment,
  ReportRuleInstanceFragment,
} from '../../fragments';

export interface ListRuleInstancesQueryData {
  listRuleInstances: {
    questionInstances: QuestionRuleInstanceWithTags[];
    reportInstances: RuleInstance[];
    pageInfo: PageInfo;
  };
}

export interface ListRuleInstancesQueryVariables {
  limit?: number | null;
  cursor?: string | null;
  filters?: {
    tags?: string[] | null;
  } | null;
}

export const ListRuleInstancesQuery = gql`
  query ListRuleInstances(
    $limit: Int
    $cursor: String
    $filters: ListRuleInstancesFilters
  ) {
    listRuleInstances(limit: $limit, cursor: $cursor, filters: $filters) {
      questionInstances {
        ...QuestionRuleInstanceFragment
      }
      reportInstances {
        ...ReportRuleInstanceFragment
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${QuestionRuleInstanceFragment}
  ${ReportRuleInstanceFragment}
`;

export const useListRuleInstancesQuery = createUseQueryHook<
  ListRuleInstancesQueryData,
  ListRuleInstancesQueryVariables
>(ListRuleInstancesQuery);
